export * from './app';
export * from './auth';
export * from './carriers';
export * from './firebase';
export * from './ui';
export * from './validation';

export const APP_CONSTANTS = {
  APP_NAME: 'MedTrack',
  APP_VERSION: '0.1.0',
  ROLE_HIERARCHY: {
    'guest': 0,
    'agent': 1,
    'upline': 2,
    'manager': 3,
    'admin': 4,
    'agency-owner': 4,
    'imo': 5
  },
  ROLE_SETTINGS: {
    guest: {
      canEditSubmission: false,
      canViewTeamMetrics: false,
      canManageUsers: false,
      canAccessReports: false,
      submissionEditWindow: 0
    },
    agent: {
      canEditSubmission: true,
      canViewTeamMetrics: false,
      canManageUsers: false,
      canAccessReports: false,
      submissionEditWindow: 24
    },
    manager: {
      canEditSubmission: true,
      canViewTeamMetrics: true,
      canManageUsers: false,
      canAccessReports: false,
      submissionEditWindow: 24
    },
    admin: {
      canEditSubmission: true,
      canViewTeamMetrics: true,
      canManageUsers: true,
      canAccessReports: true,
      submissionEditWindow: 24
    },
    imo: {
      canEditSubmission: true,
      canViewTeamMetrics: true,
      canManageUsers: true,
      canAccessReports: true,
      submissionEditWindow: 24
    },
    'agency-owner': {
      canEditSubmission: true,
      canViewTeamMetrics: true,
      canManageUsers: true,
      canAccessReports: true,
      submissionEditWindow: 24
    },
    upline: {
      canEditSubmission: true,
      canViewTeamMetrics: true,
      canManageUsers: false,
      canAccessReports: false,
      submissionEditWindow: 24
    }
  }
};
